import RuleEngineVersions from "features/datastream-config/screens/RuleEngineVersions";
import RuleEngineVersionForm from "features/datastream-config/screens/RuleEngineVersionForm";
import RuleEngineRuleList from "features/datastream-config/screens/RuleEngineRuleList";
import VersionRuleForm from "features/datastream-config/screens/VersionRuleForm";
import RulePriority from "features/datastream-config/screens/rulePriority/RulePriority";
import GeographicalControl from "features/datastream-config/screens/geographical/GeographicalControl";
import AddGeographicalArea from "features/datastream-config/screens/geographical/AddGeographicalArea";
import FieldConfigJson from "features/datastream/fieldConfig/FieldConfigJson";
import RulePrioritySelectable from "features/datastream-config/screens/rulePriority/RulePrioritySelectable";
import DataStreamReport from "features/datastream-config/screens/DataStreamReport";
import ConfigAutoRule from "features/datastream-config/screens/ConfigAutoRule";

export const datastreamConfigRoutes = [
  {
    path: "selected-datastream/rule-engine/versions",
    element: <RuleEngineVersions />,
  },
  {
    path: "selected-datastream/rule-engine/versions/create",
    element: <RuleEngineVersionForm />,
  },
  {
    path: "selected-datastream/rule-engine/versions/:versionId",
    element: <RuleEngineVersionForm />,
  },
  {
    path: "selected-datastream/rule-engine/versions/:versionId/rule",
    element: <RuleEngineRuleList />,
  },
  {
    path: "selected-datastream/rule-engine/versions/:versionId/autorule",
    element: <ConfigAutoRule />,
  },
  {
    path: "selected-datastream/rule-engine/versions/:versionId/rule/add",
    element: <VersionRuleForm />,
  },
  {
    path: "selected-datastream/rule-engine/versions/:versionId/rule/:overviewId",
    element: <VersionRuleForm />,
  },
  {
    path: "selected-datastream/rule-engine/versions/:versionId/rule/priority",
    element: <RulePriority />,
  },
  {
    path: "selected-datastream/rule-engine/versions/:versionId/rule/priority-selectable",
    element: <RulePrioritySelectable />,
  },
  {
    path: "selected-datastream/geographical-control",
    element: <GeographicalControl />,
  },
  {
    path: "selected-datastream/geographical-control/create",
    element: <AddGeographicalArea />,
  },
  {
    path: "selected-datastream/geographical-control/:geographicId",
    element: <AddGeographicalArea />,
  },
  {
    path: "selected-datastream/report/:dataStreamConfigId",
    element: <DataStreamReport />,
  },
  {
    path: "selected-datastream/config-json/:dataStreamConfigId",
    element: <FieldConfigJson />,
  },
];
